import React, {useMemo} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../core/AppLayout";
import {Topbar} from "./Topbar";
// import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {AnimateLoading} from "../../../_partials/controls";
import LeftTopbar from "./LeftTopbar";
import {useAppSession} from "../../../layout/core/AppSession";

export function Header() {
    const uiService = useHtmlClassService();
    const appModule = useAppSession();

    const layoutProps = useMemo(() => {
        return {
            headerClasses: uiService.getClasses("header", true),
            headerAttributes: uiService.getAttributes("header"),
            headerContainerClasses: uiService.getClasses("header_container", true),
            menuHeaderDisplay: objectPath.get(
                uiService.config,
                "header.menu.self.display"
            )
        };
    }, [uiService]);

    const moduleConfig = useMemo(() => {
        return appModule.currentModuleConfig;
    }, [appModule]);

    return (
        <>
            {/*begin::Header*/}
            <div id="od_header" className={`header ${layoutProps.headerClasses}`} {...layoutProps.headerAttributes} style={{ backgroundColor : moduleConfig.bg }}>
                {/*begin::Container*/}
                <div className={`${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}>
                    <AnimateLoading/>

                    <LeftTopbar/>

                    {/*begin::Header Menu Wrapper*/}
                    {/*{layoutProps.menuHeaderDisplay && <HeaderMenuWrapper/>}*/}
                    {/*end::Header Menu Wrapper*/}

                    {/*begin::Topbar*/}
                    <Topbar/>
                    {/*end::Topbar*/}
                </div>
                {/*end::Container*/}
            </div>
            {/*end::Header*/}
        </>
    );
}
